import { render, staticRenderFns } from "./Inforact.vue?vue&type=template&id=5fb4362b&scoped=true"
import script from "./Inforact.vue?vue&type=script&lang=js"
export * from "./Inforact.vue?vue&type=script&lang=js"
import style0 from "./Inforact.vue?vue&type=style&index=0&id=5fb4362b&prod&scoped=true&lang=css"
import style1 from "./Inforact.vue?vue&type=style&index=1&id=5fb4362b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb4362b",
  null
  
)

export default component.exports